/*
 * ---------------------------------------------------------------------------
 * Precio sin impuestos — ficha de producto, solo Argentina.
 *
 * El bloque `ironside-precio-sin-impuestos-ar` sale del servidor con el monto
 * de la variante seleccionada, ya formateado por Liquid. Al cambiar de variante
 * sin recargar, el tema vuelve a renderizar la sección y avisa con
 * `variant:update`, llevando el HTML nuevo en `detail.data.html` — el mismo
 * evento del que se sirve `product-price.js` para actualizar el precio.
 *
 * Ese HTML ya trae el bloque con el monto correcto. Lo único que faltaba era
 * alguien que lo leyera: sin esto el monto se quedaba en el de la primera
 * variante mientras el precio de al lado sí cambiaba, que en Argentina es un
 * precio legal mostrando un valor que no corresponde.
 *
 * Acá no se calcula ni se formatea nada: el monto se copia tal como vino del
 * servidor. Es a propósito. Un solo lugar arma los montos y no hay dos
 * redondeos ni dos separadores de miles que puedan divergir.
 *
 * El sufijo `-ar` lo pone en COUNTRY_LOCAL_GLOBS: nunca se reparte a México ni
 * a Chile. Ver docs/multi-store.md.
 *
 * No confundir con `ironside-precio-sin-impuestos.js`, que es el del carrito y
 * el checkout, vive en las tres tiendas y se prende desde la configuración del
 * tema. Este es solo de la ficha, y lo carga el propio bloque.
 * ---------------------------------------------------------------------------
 */
(function () {
  if (window.__IRONSIDE_SIN_IMP_FICHA_AR__) return;
  window.__IRONSIDE_SIN_IMP_FICHA_AR__ = true;

  var BLOQUE = '[data-ironside-sin-imp-ar]';
  var VALOR = '[data-ironside-sin-imp-valor]';
  var MAPA = '[data-ironside-sin-imp-ar-json]';

  function escapar(valor) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(valor);
    return valor.replace(/["\\]/g, '\\$&');
  }

  // El equivalente en el HTML nuevo. Se busca por id de bloque porque en la
  // página puede haber más de una ficha —un modal de compra rápida, por
  // ejemplo—; si el bloque viene sin id, alcanza con el primero.
  function equivalente(html, bloque) {
    var id = bloque.getAttribute('data-block-id');
    return html.querySelector(id ? BLOQUE + '[data-block-id="' + escapar(id) + '"]' : BLOQUE);
  }

  function actualizar(evento) {
    var detalle = evento.detail || {};
    var datos = detalle.data || {};
    var html = datos.html;

    if (!html || typeof html.querySelector !== 'function') return;

    // Mismo ámbito que escuchan los componentes del tema: la sección (o el
    // diálogo) de donde salió el cambio. Sin esto, cambiar de variante en un
    // modal reescribiría también el bloque de la ficha de atrás.
    var ambito = document;

    if (evento.target && typeof evento.target.closest === 'function') {
      ambito = evento.target.closest('.shopify-section, dialog') || document;
    }

    Array.prototype.forEach.call(ambito.querySelectorAll(BLOQUE), function (bloque) {
      var nuevo = equivalente(html, bloque);

      if (!nuevo) return;

      var destino = bloque.querySelector(VALOR);
      var origen = nuevo.querySelector(VALOR);

      // Si el bloque nuevo vino sin monto —variante agotada, precio en cero—
      // se deja el que estaba: mejor un dato viejo por un instante que la
      // línea vacía.
      if (!destino || !origen) return;

      destino.textContent = origen.textContent;
      bloque.setAttribute('data-variant-id', nuevo.getAttribute('data-variant-id') || '');

      // El mapa variante → monto lo lee el JS del carrito al agregar. En un
      // listado combinado la variante nueva es de otro producto y el mapa
      // viejo no la tiene, así que se reemplaza junto con el monto.
      var mapaViejo = bloque.querySelector(MAPA);
      var mapaNuevo = nuevo.querySelector(MAPA);

      if (mapaViejo && mapaNuevo) mapaViejo.textContent = mapaNuevo.textContent;
    });
  }

  // En captura, igual que el resto del JS de precio de esta tienda: el evento
  // burbujea desde la sección y así llega aunque algo lo detenga en el camino.
  document.addEventListener('variant:update', actualizar, true);
})();
